/* eslint-disable angular/controller-name, angular/controller-as */

angular.module("digiexam").controller("SaveAsNewController", SaveAsNewController);

function SaveAsNewController(
	$scope,
	dxDialog
) {
	"use strict";

	$scope.showErrorMessage = false;

	$scope.cancel = function cancel() {
		dxDialog.closeMostRecent();
	};

	$scope.save = function save() {
		if ($scope.item.title.length === 0) {
			return;
		}

		$scope.saveAsNew($scope.item.title);
		dxDialog.closeMostRecent();
	};
}
